import React from "react";
import accounts from "../images/accounts.jpeg";
import banking from "../images/banking.jpeg";
import communication from "../images/communication.jpeg";
import customer from "../images/customer.jpeg";
import data from "../images/data.jpeg";
import education from "../images/education.jpeg";
import healthcare from "../images/healthcare.jpeg";
import hospitality from "../images/hospitality.png";
import Hr from "../images/Hr.jpeg";
import insurance from "../images/insurance.jpeg";
import IT from "../images/IT.jpeg";
import logistic from "../images/logistic.jpeg";
import manufacturing from "../images/manufacturing.jpeg";
import marketing from "../images/marketing.jpeg";
import product from "../images/product.jpeg";
import project from "../images/project.jpeg";
import realestate from "../images/realestate.jpeg";
import retail from "../images/retail.jpeg";
import sales from "../images/sales.jpeg";

function page5() {
  return (
    <div>
      <div className="pt-10 pl-12 font-bold text-3xl text-center">
        Browse through all different categories
      </div>

      <div className="grid grid-cols-7 gap-2 mt-40 pl-14 ">
        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={accounts} alt="accounts" className="w-10"></img>

              <p className="text-xs mt-2  ">Accounting & Finance</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={banking} alt="banking" className="w-10"></img>

              <p className="text-xs mt-2  ">Banking & Operations</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img
                src={communication}
                alt="communication"
                className="w-10"
              ></img>

              <p className="text-xs mt-2  ">Communication & Media</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={customer} alt="customer" className="w-10"></img>

              <p className="text-xs mt-2  ">Customer Management</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={data} alt="datament" className="w-10"></img>

              <p className="text-xs mt-2  ">Data Management</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={education} alt="education" className="w-10"></img>

              <p className="text-xs mt-2  ">Education & E-learning</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={healthcare} alt="healthcare" className="w-10"></img>

              <p className="text-xs mt-2  ">Healthcare & Medical</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={hospitality} alt="hospitality" className="w-10"></img>

              <p className="text-xs mt-2  ">Hospitality and Travel </p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={Hr} alt="Hr&talent" className="w-10"></img>

              <p className="text-xs mt-2  ">HR & Talent</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={insurance} alt="insurance" className="w-10"></img>

              <p className="text-xs mt-2  ">Insurance</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={IT} alt="IT" className="w-10"></img>

              <p className="text-xs mt-2  ">IT Security</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={logistic} alt="logistic" className="w-10"></img>

              <p className="text-xs mt-2 text-center">
                Logistics & Supply Chain
              </p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img
                src={manufacturing}
                alt="manufacturing"
                className="w-10"
              ></img>

              <p className="text-xs mt-2 text-center">
                Manufacturing & Engineering
              </p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={marketing} alt="marketing" className="w-10"></img>

              <p className="text-xs mt-2  ">Marketing</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={product} alt="product" className="w-10"></img>

              <p className="text-xs mt-2  ">Product</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={project} alt="project" className="w-10"></img>

              <p className="text-xs mt-2  ">Project Management</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={realestate} alt="realestate" className="w-10"></img>

              <p className="text-xs mt-2  ">Real Estate</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={retail} alt="retail" className="w-10"></img>

              <p className="text-xs mt-2  ">Retail & Consumer</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>

        <div className="w-32 h-24 mb-4 transform hover:scale-110 hover:bg-opacity-50">
          <div className=" rounded-lg w-32 h-24 shadow-lg ">
            <a
              href="www.google.com"
              className="grid grid-cols-1  place-items-center pt-4 "
            >
              <img src={sales} alt="sales" className="w-10"></img>

              <p className="text-xs mt-2  ">Sales</p>
            </a>
          </div>
          <div className="text-xs text-purple-800 bg-purple-200 rounded-b-lg pl-12 ">
            xyz
          </div>
        </div>
      </div>
    </div>
  );
}
export default page5;
